
    const state = {
            menuItem:{},        //组件页面头部标题
            dialogFormVisible:Boolean,
            headMenu:[],
            fontColor:'',
            skinColor:'',
        }
        const getters = {
    //         getUserInfomation: state => state.userInfomation,
    
        }
        const mutations = {           
            setMenuItem(state,menuItem){
                state.menuItem = menuItem
            },
            setHeadMenu(state,headMenu){
                state.headMenu = headMenu
            },
            setFormVisible(state,dialogFormVisible){
                state.dialogFormVisible = dialogFormVisible
            },
            setfontColor(state,fontColor){
                state.fontColor = fontColor
            },
            setskinColor(state,skinColor){
                state.skinColor = skinColor
            },
        }
        const actions = {
            setMenuItem({commit},menuItem){
                commit('setMenuItem',menuItem)
            },
            setHeadMenu({commit},headMenu){
                commit('setHeadMenu',headMenu)
            },
            setFormVisible({commit},dialogFormVisible){
                commit('setFormVisible',dialogFormVisible)
            },
            setfontColor({commit},fontColor){
                commit('setfontColor',fontColor)
            },
            setskinColor({commit},skinColor){
                commit('setskinColor',skinColor)
            },
        }
        export default {
            state,
            getters,
            mutations,
            actions,
            namespaced: true,
        }
    


// WEBPACK FOOTER //
// ./src/store/module/userindex.js